import React, { useEffect, createElement } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { TutorialVideoSection } from '../TutorialVideoSection';
export const TutorialPage = () => {
  useEffect(() => {
    document.title = 'Tutorial — Maestro Connect';
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Watch our tutorial to learn how to get started with Maestro Connect.';
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-10422">
      <Navbar data-id="element-10423" />
      <main className="pt-20" data-id="element-10424">
        <TutorialVideoSection data-id="element-10425" />
      </main>
      <Footer data-id="element-10426" />
    </div>;
};